<ion-button (click)="settings.open()" fill="clear"><ion-icon slot="icon-only" size="large" name="settings"></ion-icon></ion-button>
